import { IModuleSettings } from "../interfaces/IModuleSettings";

// A list of allowed modules 
export const moduleTypesList = [ 
    { "name": "takeaway", "type": 1, "translationKey": "common:Takeaway" }, 
    { "name": "clickandcollect", "type": 0, "translationKey": "common:ClickAndCollect" }, 
    { "name": "orderattable", "type": 2, "translationKey": "common:OrderAtTable" }, 
    { "name": "roomservice", "type": 7, "translationKey": "common:Roomservice" }, 
    { "name": "fasttrack", "type": 6, "translationKey": "common:Fasttrack" }
];

// View settings for each module
export const moduleSettings: IModuleSettings = {
    "default": { // default is the same as inhouse/OAT, since it's almost always comming from POS
        "counter": true,
        "table": true,
        "orderReadyTime": false
    },
    0: {
        "counter": true,
        "table": false,
        "orderReadyTime": false
    },
    1: {
        "counter": false,
        "table": false,
        "orderReadyTime": true
    },
    2: {
        "counter": true,
        "table": true,
        "orderReadyTime": false
    },
    6: {
        "counter": false,
        "table": false,
        "orderReadyTime": true
    },
    7: {
        "counter": true,
        "table": true,
        "orderReadyTime": false
    }
}